const URL_REGEX = /https?:\/\/[^\s<>"{}|\\^`[\]]+/g;

/** Returns true if the entire string is a single URL. */
export function isUrl(text: string): boolean {
  const trimmed = text.trim();
  if (!trimmed) return false;
  const match = trimmed.match(/^https?:\/\/[^\s<>"{}|\\^`[\]]+$/);
  return match !== null;
}

/** Extracts all URLs from a string. */
export function extractUrls(text: string): string[] {
  const matches = text.match(URL_REGEX);
  return matches ?? [];
}
